import * as React from "react";

import gql from "graphql-tag";
import { graphql } from "react-apollo";

import { fragments as deviceFraudCommentsFragments } from "./Fragment.FraudCommentsParts";

import DeviceFraudComments, {
  deviceFraudCommentsSimple as DeviceFraudCommentsSimple,
} from "./DeviceFraudComments";

import LinkUsersAndDevicesTable, {
  fragments as linkedUsersAndDevicesTableFragments,
} from "./LinkedUsersAndDevicesTable";
import FraudStatusIcon from "./FraudStatusIcon";
import BOGraphQLLoader from "app/components/BOComponents/BOGraphQLLoader";

export const fraudStatusDetailsQuery = gql`
  ${linkedUsersAndDevicesTableFragments.linkedUserParts}
  ${deviceFraudCommentsFragments.fraudCommentsParts}

  query fraudStatusDetailsQuery($deviceExternalReference: ID!) {
    devices(external_reference: $deviceExternalReference) {
      ...FraudCommentsParts
      user {
        linked_users {
          ...LinkedUserParts
        }
      }
    }
  }
`;

type QueryProps = { deviceExternalReference: string; data?: any };

class FraudStatusDetails extends React.Component<QueryProps> {
  render() {
    const devices = this.props.data.devices;
    const device = devices && devices[0];

    const Details = () => (
      <div>
        <DeviceFraudCommentsSimple device={device} />
        <h3>Linked users and devices</h3>
        <LinkUsersAndDevicesTable linkedUsers={device.user.linked_users} />
      </div>
    );

    return (
      <BOGraphQLLoader data={this.props.data}>
        <Details />
      </BOGraphQLLoader>
    );
  }
}

const FraudStatusDetailsWithData = graphql<any, QueryProps>(
  fraudStatusDetailsQuery,
  {
    options: ({ deviceExternalReference }: QueryProps) => {
      return {
        variables: {
          deviceExternalReference,
        },
      };
    },
  }
)(FraudStatusDetails);

type IconProps = {
  fraudStatus?: string;
  device: {
    device_only_fraud_status: string;
    external_reference: string;
  };
};

export const DeviceFraudStatusIcon = ({ device, fraudStatus }: IconProps) => (
  <FraudStatusIcon
    fraudStatus={fraudStatus || device.device_only_fraud_status}
    popoverContents={
      <DeviceFraudComments
        deviceExternalReference={device.external_reference}
      />
    }
  >
    {device.external_reference ? (
      <FraudStatusDetailsWithData
        deviceExternalReference={device.external_reference}
      />
    ) : null}
  </FraudStatusIcon>
);
